export { PrayRewardSharedScreen as PrayRewardScreen } from './PrayRewardSharedScreen'
